export type SocialPlatform = "instagram" | "tiktok";

const INSTAGRAM_PATH_PREFIXES = ["/reel/", "/reels/", "/p/", "/tv/"];

export function normalizeExternalUrl(input: string) {
  const trimmed = input.trim();
  if (!trimmed) {
    return "";
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
}

function matchesHost(hostname: string, domain: string) {
  const normalizedHost = hostname.toLowerCase();
  return normalizedHost === domain || normalizedHost.endsWith(`.${domain}`);
}

export function isValidSocialUrl(input: string, platform: SocialPlatform) {
  const normalizedUrl = normalizeExternalUrl(input);
  if (!normalizedUrl) {
    return false;
  }

  try {
    const parsedUrl = new URL(normalizedUrl);

    if (parsedUrl.protocol !== "https:" && parsedUrl.protocol !== "http:") {
      return false;
    }

    const pathname = parsedUrl.pathname.toLowerCase();

    if (platform === "instagram") {
      return matchesHost(parsedUrl.hostname, "instagram.com") && INSTAGRAM_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
    }

    return matchesHost(parsedUrl.hostname, "tiktok.com") && pathname !== "/" && pathname !== "";
  } catch {
    return false;
  }
}
